<app-terminal-overlay
    (closeRequested)="onCloseRequested()"
    [title]="title()"
    subtitle="{{ 'GENERAL.SUBTITLE.SELECT_LOCATION' | translate }}"
    icon="fa-location-dot"
    data-test="row-selection-page"
>
    <app-map-filter header data-test="map-navigation" />

    @if (isRowSelectionInProgress$ | async) {
        <ng-container data-footer>
            <app-map-row-selector-toolbar />
        </ng-container>
    }

    @if (!!selectedActivity()) {
        <app-map-row-list [activity]="selectedActivity()" />
    }
</app-terminal-overlay>
